import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomTabsWithParams from "../../components/widgets/customTabs/CustomTabsWithParams";
import TagOperationsPage from "../tagOperation/TagOperationsPage";
import ClientStatusPage from "../client/clientStatus/ClientStatusPage";
import CategoriesPage from "../client/categories/CategoriesPage";
import RelationTypesPage from "../client/relationTypes/RelationTypesPage";

const ClientTagsPage = () => {
    const contentTabs = [
        {
            eventKey: "categories",
            title: "Catégories",
            unmountOnExit: false,
            mountOnEnter: true,
            content: <CategoriesPage />
        },
        {
            eventKey: "clientStatus",
            title: "Statuts",
            unmountOnExit: false,
            mountOnEnter: true,
            content: <ClientStatusPage />
        },
        {
            eventKey: "tagOperations",
            title: "Tags opérations",
            unmountOnExit: false,
            mountOnEnter: true,
            content: <TagOperationsPage />
        },
        {
            eventKey: "relationTypes",
            title: "Natures de la relation",
            unmountOnExit: false,
            mountOnEnter: true,
            content: <RelationTypesPage />
        }
    ];

    return <Container fluid>
        <Row>
            <Col><h2>Étiquettes client</h2></Col>
        </Row>
        <CustomTabsWithParams
            contentTabs={contentTabs}
            id="client-tags-tab"
            className="mt-0"
            defaultActiveTabId="categories"
        />
    </Container>;
}
export default ClientTagsPage;